import styled from "styled-components";

export const Overlay = styled.div`
    position: fixed;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2100;
`;

export const Modal = styled.div`
    background-color: white;
    width: 480px;
    border-radius: 12px;
    padding: 0;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.25);
    overflow: hidden;
`;

export const Header = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #f4f2ff;
    padding: 20px 24px;
    margin-bottom: 0;
`;

export const Title = styled.h2`
    font-family: "IBM Plex Sans";
    font-weight: 500;
    font-size: 19px;
    line-height: 100%;
    letter-spacing: 0;
    margin: 0;
`;

export const CloseBtn = styled.button`
    background: none;
    border: none;
    font-size: 18px;
    cursor: pointer;
`;

export const Form = styled.form`
    display: flex;
    flex-direction: column;
    gap: 14px;
    padding: 24px;
`;

export const Label = styled.label`
    display: flex;
    flex-direction: column;
    gap: 20px;
    font-family: "IBM Plex Sans";
    font-weight: 400;
    font-size: 16px;
    line-height: 100%;
    letter-spacing: 0;
    color:#4B464F;
`;

export const Input = styled.input`
    padding: 20px;
    border-radius: 6px;
    border: 1px solid #ccc;
    font-size: 14px;
    box-sizing: border-box;
`;

export const Textarea = styled.textarea`
    padding: 10px;
    border-radius: 6px;
    border: 1px solid #ccc;
    font-size: 14px;
    resize: none;
     &::placeholder {
    font-family: "IBM Plex Sans", sans-serif;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0px;

    color: #918B97; 
    opacity: 1; 
  }
`;

export const SubmitBtn = styled.button`
    margin-top: 10px;
    background: #3d237a;
    color: #fff;
    border: none;
    padding: 8px;
    border-radius: 24px;
    font-size: 16px;
    cursor: pointer;
    font-weight:500;
    font-family:"IBM Plex Sans";
    line-height:24px;

    &:hover {
        opacity: 0.9;
    }
`;